module.exports = __webpack_public_path__ + "static/media/EV-Financier-of-the-Year-2023.bb29e2b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/EV-Financier-of-the-Year-2023.jpg
// module id = 347
// module chunks = 0